module.exports = __webpack_public_path__ + "img/Z82_02.8e836204.jpg";